import React from "react";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styled from "styled-components";
import { breakpoint, theme } from "@utilities";

interface DiscountInfoModalProps {
    isOpen: boolean;
    onClose: () => void;
    percent: number;
    imageUrl?: string;
    learnMoreHref: string;
}

const Image = styled.img`
    width: 100%;
    max-height: 260px;
    object-fit: cover;
    border-radius: 12px 12px 0 0;
    border-radius: 4px;
`;

const Content = styled.div`
    text-align: center;
    padding: 34px 0px;
    ${breakpoint.breakTablet`
    padding: 34px 26px;
  `}
`;

const Headline = styled.div`
    font-size: 1.5rem;
    font-family: "Poppins";
    font-weight: 500;
    margin-bottom: 16px;
`;

const Subtext = styled.div`
    font-family: "Poppins";
    font-size: 1rem;
    line-height: normal;
    color: #222;
    margin-bottom: 24px;
    span {
        color: ${theme.colors.highlight};
        font-weight: 700;
    }
`;

const StyledLinkButton = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 278px;
    margin: 0 auto;
    height: 54px;
    background: linear-gradient(90deg, ${theme.gradients.button[0]}, ${theme.gradients.button[1]});
    color: ${theme.colors.button_text};
    font-family: "Poppins";
    font-style: normal;
    font-size: 1rem;
    margin-top: 8px;
    border-radius: 4px;
    gap: 8px;
    text-align: center;
    text-decoration: none;
    border: none;
    cursor: pointer;
    transition: background 0.2s;
    &:hover {
        background: linear-gradient(
            90deg,
            ${theme.gradients.button[0]},
            ${theme.gradients.button[1]}
        );
        color: #fff;
        text-decoration: none;
    }
`;

export const DiscountInfoModal: React.FC<DiscountInfoModalProps> = ({
    isOpen,
    onClose,
    percent,
    imageUrl = "/images/website/banner/modal-header.png",
    learnMoreHref,
}) => (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm">
        <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
                position: "absolute",
                right: 16,
                top: 16,
                color: "#fff",
                background: "rgba(0,0,0,0.3)",
                zIndex: 2,
            }}
        >
            <CloseIcon />
        </IconButton>
        <Image src={imageUrl} alt="Discount" />
        <DialogContent
            style={{
                backgroundColor: "#fff",
                backgroundImage: "url('/images/website/banner/modal-content-bg.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }}
        >
            <Content>
                <Headline>Enjoy up to {percent}% OFF !</Headline>
                <Subtext>
                    Kick off your adventure with up to <span>{percent}% OFF</span>, just for you!
                </Subtext>
                <StyledLinkButton href={learnMoreHref} rel="noopener" target="_blank">
                    Learn More
                </StyledLinkButton>
            </Content>
        </DialogContent>
    </Dialog>
);
